<template>
  <div class="top-customers-chart">
    <!-- 加载状态 -->
    <div v-if="loading" class="chart-loading">
      <i class="el-icon-loading"></i>
      <span>数据加载中...</span>
    </div>

    <!-- 空数据状态 -->
    <div v-else-if="!hasData" class="chart-empty">
      <i class="el-icon-s-data"></i>
      <span>暂无数据</span>
    </div>

    <!-- 图表容器 -->
    <div v-else ref="chart" class="chart-container"></div>
  </div>
</template>

<script>
import echarts from 'echarts'

export default {
  name: 'top-customers-chart',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      chart: null,
      resizeHandler: null
    }
  },

  computed: {
    hasData() {
      return this.data && this.data.length > 0
    },

    chartData() {
      if (!this.hasData) return { names: [], values: [] }

      const names = []
      const values = []

      this.data.forEach(item => {
        names.push(item.customerName || item.customerCode || '未知客户')
        values.push(item.totalTimes || 0)
      })

      return { names, values }
    }
  },

  watch: {
    data: {
      handler() {
        this.$nextTick(() => {
          if (this.hasData && !this.chart) {
            this.initChart()
          } else if (this.chart) {
            this.renderChart()
          }
        })
      },
      deep: true
    },

    loading(newVal) {
      if (!newVal && this.hasData) {
        this.$nextTick(() => {
          if (!this.chart) {
            this.initChart()
          } else {
            this.renderChart()
          }
        })
      }
    }
  },

  mounted() {
    this.initChart()
    this.bindEvents()
  },

  beforeDestroy() {
    this.unbindEvents()
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },

  methods: {
    initChart() {
      if (!this.$refs.chart) return
      this.chart = echarts.init(this.$refs.chart)
      this.renderChart()
    },

    renderChart() {
      // 先检查数据，无数据时销毁图表实例
      if (!this.hasData) {
        if (this.chart) {
          this.chart.dispose()
          this.chart = null
        }
        return
      }

      if (!this.chart) return

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: '{b}<br/>{a}: {c} 次',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          borderColor: '#e8eaec',
          borderWidth: 1,
          textStyle: {
            color: '#1f2d3d'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '5%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            color: '#606266',
            fontSize: 11
          },
          splitLine: {
            lineStyle: {
              color: '#e8eaec',
              type: 'dashed'
            }
          }
        },
        yAxis: {
          type: 'category',
          data: this.chartData.names,
          axisLabel: {
            color: '#606266',
            fontSize: 11,
            formatter: (value) => {
              return value.length > 8 ? value.substring(0, 8) + '...' : value
            }
          },
          axisLine: {
            lineStyle: {
              color: '#e8eaec'
            }
          }
        },
        series: [
          {
            name: '调用次数',
            type: 'bar',
            data: this.chartData.values,
            barWidth: '60%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: '#667eea' },
                { offset: 1, color: '#764ba2' }
              ]),
              borderRadius: [0, 4, 4, 0]
            },
            label: {
              show: true,
              position: 'right',
              color: '#1f2d3d',
              fontSize: 11
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  { offset: 0, color: '#764ba2' },
                  { offset: 1, color: '#667eea' }
                ])
              }
            }
          }
        ]
      }

      this.chart.setOption(option, true)
    },

    bindEvents() {
      this.resizeHandler = () => {
        if (this.chart) {
          this.chart.resize()
        }
      }
      window.addEventListener('resize', this.resizeHandler)
    },

    unbindEvents() {
      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler)
        this.resizeHandler = null
      }
    }
  }
}
</script>

<style scoped>
.top-customers-chart {
  height: 100%;
  position: relative;
  background: linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%);
  border-radius: 12px;
  padding: 8px;
}

.chart-container {
  width: 100%;
  height: 320px;
}

.chart-loading,
.chart-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 320px;
  color: #909399;
  font-size: 14px;
}

.chart-loading i,
.chart-empty i {
  font-size: 48px;
  margin-bottom: 12px;
}
</style>




// WEBPACK FOOTER //
// src/custom/components/stats/face-stats/components/top-customers-chart.vue